import { render } from "./ApprovedOrdersPage.vue?vue&type=template&id=ff372b70&lang=html"
import script from "./ApprovedOrdersPage.vue?vue&type=script&lang=js"
export * from "./ApprovedOrdersPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__